import { useFeedbackGlobalModal } from "components/FeedbackForm/FeedbackFormDialog";
import { useEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import { ButtonBadge } from "prism-react";

import { BranchStatus } from "./BranchStatus";
import { SandboxStatus } from "./SandboxStatus";

export const EditorStatus: React.FC = () => {
  const session = useSession();
  const editor = useEditor();
  const feedbackModal = useFeedbackGlobalModal();

  return (
    <>
      {editor.type === "sandbox" ? <SandboxStatus /> : <BranchStatus />}
      {session[0].state === "AUTHENTICATED" && (
        <ButtonBadge icon="chat" onClick={feedbackModal.open}>
          Feedback
        </ButtonBadge>
      )}
    </>
  );
};
